import styled from "styled-components";
import { useState } from "react";
import { useHistory } from "react-router-dom";

import ApplicationTypeCard from "../framework/components/view/ApplicationTypeCard";
import LogoIconComponent from "../framework/components/iconComponents/LogoIconComponent";
import { BackArrowCreateApplicationIcon } from "../framework/components/modal/modalIcons";
import { useTheme, useVariables } from "../features/context/CustomerContext";
import useCustomTranslation from "../features/hooks/CustomUseTranslation";

const Div = styled.div`
    @media screen and (min-width: ${props => props.theme.mobileMenuBreakpoint}px) {
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin: 0px auto 60px auto;
        width: 1035px;
        font-size: 16px;
    }
    @media screen and (min-width: ${props => props.theme.mobileMenuBreakpoint}px) {
        width: auto;
        margin: 0px 250px 60px 250px;
    }
    font-size: 12px;
    height: 700px;
    margin: 20px;
    background-color: white;
`
const ButtonContainer = styled.div`
    display: flex;
    padding: 21px 75px 0 30px;
    @media screen and (max-width: 470px) {
        padding: 20px 0 0 0;
    }
`
const Body = styled.div`
    text-align: center;
`
const ClickableDiv = styled.div`
    cursor: pointer;
`
const CardContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 2rem;
    @media screen and (max-width: 1000px) {
        flex-direction: column;
        align-items: center;
        margin-left: 0px;
        margin-right: 0px;
    }
`

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;

`

const ApplicationSelectView: React.FC = () => {
    const { t } = useCustomTranslation();
    const history = useHistory();
    const [showEnterpriseView, setShowEnterpriseView] = useState<boolean>(false);
    const theme = useTheme();
    const variables = useVariables();

    return (
        <Div theme={theme}>
            <ButtonContainer>
                <BackArrowCreateApplicationIcon theme={theme}
                    type="button"
                    onClick={showEnterpriseView ? () => setShowEnterpriseView(false) : history.goBack}>
                </BackArrowCreateApplicationIcon>
                {variables.showCustomerLogoOnRepresentationPages &&
                        <LogoIconComponent style={{ marginLeft: 'auto', marginRight: 'auto', marginBottom: '1rem' }}></LogoIconComponent>
                }
            </ButtonContainer>
            <Body>
                <CardWrapper className="card-wrapper">
                    <div style={{ marginTop: variables.showCustomerLogoOnRepresentationPages ? '0': '5rem' }}>
                        {!showEnterpriseView ?
                            <CardContainer>
                                <ClickableDiv onClick={() => history.push('createApplication')}>
                                    <ApplicationTypeCard
                                        cardTitle={t("New application personal card title")}
                                        infoText={t("New application personal card info text")}
                                        enterpriseApplication={false}
                                    />
                                </ClickableDiv>
                                <ClickableDiv onClick={() => setShowEnterpriseView(true)}>
                                    <ApplicationTypeCard
                                        cardTitle={t("New application enterprise card title")}
                                        infoText={t("New application enterprise card info text")}
                                        enterpriseApplication={true}
                                    />
                                </ClickableDiv>
                            </CardContainer>
                            :
                            <CardContainer>
                                <ClickableDiv onClick={() => history.push('linkEnterprise')}>
                                    <ApplicationTypeCard
                                        cardTitle={t("Request application enterprise card title")}
                                        infoText={t("Request application enterprise card info text first line")}
                                        infoTextSecondPart={t("Request application enterprise card info text second line")}
                                        enterpriseApplication={true}
                                    />
                                </ClickableDiv>
                                <ClickableDiv onClick={() => history.push('createApplication')}>
                                    <ApplicationTypeCard
                                        cardTitle={t("Request application employee card title")}
                                        infoText={t("Request application employee card info text")}
                                        enterpriseApplication={false}
                                    />
                                </ClickableDiv>
                            </CardContainer>
                        }
                    </div>
                </CardWrapper>
            </Body>
        </Div>
    )
}

export default ApplicationSelectView;